import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../components/Button';
import { PageHeader } from '../components/Form';
import { ListRow, SectionHeader } from '../components/PlayerUI';
import { useGuestGate } from '../context/GuestGateContext';
import { useTheme } from '../context/ThemeContext';

export default function GuestAccount() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { requireAuth } = useGuestGate();
  const { colors, isDark, toggleTheme } = useTheme();

  return (
    <main className="sls-page">
      <PageHeader title={t('profile.guest.title')} />
      <div className="sls-page-content">
        <section style={{ padding: 20, borderRadius: 14, background: colors.line }}>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700 }}>{t('profile.guest.heading')}</h1>
          <p style={{ margin: '8px 0 18px', color: colors.textSub, fontSize: 16, lineHeight: 1.5 }}>{t('profile.guest.body')}</p>
          <Button label={t('profile.guest.create')} onClick={() => navigate('/register')} />
          <Button label={t('profile.guest.signIn')} variant="text" onClick={() => navigate('/login')} style={{ marginTop: 6 }} />
        </section>
        <SectionHeader title={t('profile.guest.accountSection')} />
        <ListRow icon="receipt" label={t('profile.transactions.title')} onPress={() => requireAuth()} />
        <ListRow icon="credit-card" label={t('profile.rowsPayout.label')} onPress={() => requireAuth()} />
        <ListRow icon="bell" label={t('profile.guest.notifications')} onPress={() => requireAuth()} />
        <SectionHeader title={t('profile.guest.exploreSection')} />
        <ListRow icon="book-open" label={t('profile.guest.howItWorks')} onPress={() => navigate('/help')} />
        <ListRow icon="question-circle" label={t('faq.title')} onPress={() => navigate('/faq')} />
        <ListRow icon="moon" label={t('profile.guest.appearance')} value={isDark ? t('profile.guest.dark') : t('profile.guest.light')} onPress={toggleTheme} />
      </div>
    </main>
  );
}
